import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';

// -- actions
import { RestaurantMenuAction, RouteAction } from 'actions';

import SecurityContext from 'utils/permissions/SecurityContext';

// -- constants
import ViewConstants from 'constants/ViewConstants';

// -- entities
import Product from 'PMT/entities/menu/Product';

// -- views
import ImageLoader from 'PMT/components/ImageLoader';
import EnabledDisabledIcon from 'PMT/components/EnabledDisabledIcon';
import RowPricesView from 'components/order/RowPricesView';
import Switch from 'react-bootstrap-switch';

class ProductRow extends Component {

  static propTypes = {
    product: PropTypes.instanceOf(Product).isRequired,

    disableStockModification: PropTypes.bool.isRequired,

    onChange: PropTypes.func.isRequired,

    currencyCode: PropTypes.string,

  };

  shouldComponentUpdate(nextProps): boolean {
    return true;
    // return !nextProps.product.equals(this.props.product);
  }

  onDisplayDetail = () => {
    if (!SecurityContext.restaurantMenu.canEdit()) {
      return;
    }

    RouteAction.presentProductEdit(this.props.product);
  };

  onToggleStock = () => {
    if (!SecurityContext.restaurantMenu.canEdit() &&
      !SecurityContext.restaurantMenu.canEditAvailabilityProducts()
    ) {
      return;
    }

    const product:Product = this.props.product;

    product.toggleAvailibility();

    this.props.onChange(product);
  };

  render() {
    const product:Product = this.props.product;

    return (
      <tr className="product_row pointer">

        <td
          className="hidden-xs hidden-sm col-md-1 text-left"
          onClick={this.onDisplayDetail}
        >
          <ImageLoader
            src={product.image}
            className="product_row__image"
            placeholder={ViewConstants.Image.RestaurantMenu.NO_IMAGE_FOR_PRODUCT}
          />
        </td>

        <td
          className="product__name col-xs-10 col-sm-8"
          onClick={this.onDisplayDetail}
        >
          <h4>{product.name}</h4>
        </td>

        <td
          className="hidden-xs col-sm-3 col-md-2 text-center pointer"
        >
          <RowPricesView
            prices={product.prices}
            currencyCode={this.props.currencyCode}
          />
        </td>

        <td
          className="col-xs-1 col-sm-1 text-center"
        >
          <Switch
            bsSize="mini"
            wrapperClass="switch_important"
            value={product.haveStockAndIsActivated()}
            onChange={this.onToggleStock}
            disabled={
              (!SecurityContext.restaurantMenu.canEdit() &&
              !SecurityContext.restaurantMenu.canEditAvailabilityProducts()) || 
              this.props.disableStockModification
            }
          />
        </td>

      </tr>
    );
  }

}

export default ProductRow;
